var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sale-card",
      on: {
        click: function($event) {
          _vm.handleViewSaleEntry(_vm.sale)
        }
      }
    },
    [
      _c(
        "div",
        [
          _c("sale-info", { attrs: { sale: _vm.sale } }),
          _vm._v(" "),
          _c("div", { staticClass: "sale-name" }, [
            _vm._v(_vm._s(_vm.sale.saleName))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-gray" }, [
        _c("div", [
          _vm._v(
            "募集締切：" + _vm._s(_vm.formatDate(_vm.sale.applicationPeriodTo))
          )
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("セールID：" + _vm._s(_vm.sale.saleId))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-565b5349", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565b5349","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/sale/components/SaleCard.vue
// module id = null
// module chunks = 